import moment from 'moment';

const MERGE_FIELD_VALUES = {
  signed_date: (locale) => moment().locale(locale).format('LL')
};

export function renderMergeFields(html, locale) {
  const parser = new DOMParser();
  const document = parser.parseFromString(html, 'text/html');

  document.querySelectorAll('[data-entity-type="MERGE_FIELD"]').forEach(element => {
    const value = MERGE_FIELD_VALUES[element.dataset.key];
    element.replaceWith(value ? value(locale) : '');
  });

  return document.body.innerHTML;
}
